[
    {
        "type": "displayRegenerateDocumentsButton",
        "role": ["administrator", "broker"],
        "products": ["securemyoffer"]
    }
]
